import LInput from './LInput.vue'

export default (Vue) => {
  Vue.component(LInput.name, LInput)
}
